import React from "react";
import "./AshiThaiYogassage.css";
import useWindowDimensions from "../../components/getWindowDimensions";

function AshiThaiYogassage() {
  const { width } = useWindowDimensions();

  return (
    <div className="ashi-thai-yogassage-container">
      <div className="ashi-thai-content">
        <h1>What is Ashi-Thai Yogassage Therapy?</h1>

        <p>
          To address specific conditions or imbalances in the body, I've created
          Ashi-Thai Yogassage Therapy, which integrates Thai massage, Ashiatsu,
          and Yoga therapy. This combination of therapies is exceptionally
          beneficial for treating chronic muscular and joint pain, stemming from
          both permanent and temporary medical conditions or bodily imbalances.
          It is particularly effective for conditions such as:
        </p>

        <ul>
          <li>
            Scoliosis (which often affects the entire body and may require two
            sessions for comprehensive treatment: one for the upper body and one
            for the lower body)
          </li>
          <li>Hyperkyphosis (hunched upper back)</li>
          <li>Hyperlordosis (arched lower back)</li>
          <li>Pelvic tilts</li>
          <li>Slipped discs</li>
          <li>Sciatica</li>
          <li>Chronic pain in any part of the body</li>
          <li>And more.</li>
        </ul>

        <h2>Session Outline</h2>

        <p>
          This customized Ashi-Thai Yogassage Therapy session is not a full body
          massage; it focuses specifically on the areas needing treatment.
        </p>

        <h3>First Phase: Therapeutic Oil Massage</h3>

        <p>
          We begin with a therapeutic oil massage on the table, where the client
          is unclothed but properly draped. This phase utilizes traditional
          and/or Ashiatsu techniques to target overly tight muscles due to
          specific conditions, imbalances, or problems. To relax and prepare the
          tissues for deeper work, I may incorporate hot towels or stones and
          silicon suction cups, followed by a progressive oil massage that
          employs light but firm pressure, working deeper layers of tissue to
          relieve chronic tension in the area. To finish this portion of the
          treatment, I may use therapeutic essential oils along with hot/cold
          towels or stones.
        </p>

        <p>
          At this point, I leave the room for a couple of minutes to allow my
          client privacy to dress in comfortable, stretchy clothes.
        </p>

        <h3>Second Phase: Therapeutic Thai Massage</h3>

        <p>
          Next, I proceed with a therapeutic Thai massage on the floor mat,
          where my client is fully clothed. I utilize passive and assisted yoga
          stretches, applying rhythmic compression and other techniques to
          release tension from deep connective tissues, primarily targeting the
          joints.
        </p>

        <h3>Third Phase: Therapeutic Yoga Asana Instruction</h3>

        <p>
          Lastly, I provide therapeutic yoga asana instruction to stabilize the
          targeted area by stretching and/or strengthening different parts of
          the body. This segment is crucial for educating clients on how to
          manage their conditions at home and in between sessions.
        </p>
      </div>
    </div>
  );
}

export default AshiThaiYogassage;
